import Emitter from "./Emitter";

export default class GameRoundEnd extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        this.emitTop({ wpgaction: "gameRoundEnd" });
        this.emitParent({ wpgaction: "gameRoundEnd.parent" });
        this.emitiOS({ wpgaction: "gameRoundEnd" });
    }
}
